export enum LocalStorageKeys {
  CWCB_DISMISS_DISCLAIMER_NOTIFICATION = 'cwcb-dismiss-disclaimer-notification',
  CWCB_DISMISS_MAP_HELP_NOTIFICATION = 'cwcb-dismiss-map-help-notification',
  CWCB_DISMISS_MAP_LAYER_NOTIFICATION = 'cwcb-dismiss-map-layer-notification',
  CWCB_DISMISS_MAP_DISCLAIMER = 'cwcb-dismiss-map-disclaimer',
  CWCB_LANGUAGE_SETTING = 'cwcb-language-setting',
}
